<template>
  <div>
    <v-data-table
      disable-pagination
      style="width: 100%"
      :headers="headers"
      :items="userRideTypeWaitTimes"
      hide-default-footer
    >
      <template v-slot:item="props">
        <tr>
          <td >
            {{ props.item.id }}
          </td>
          <td>{{props.item.ride_type.name}}
          <td >{{ (props.item.fee / 100).toFixed(2) }}</td>
          <td >{{ (props.item.kick_in_time_minutes)}}</td>
          <td> <v-btn @click="remove(props.item)" x-small>Delete</v-btn></td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

export default {
  name: "user_ride_type_wait_time_list",
  components: {},
  props: {
    userRideTypeWaitTimes: Array,
    reload: Function
  },
  data: function() {
    return {
      dialog: Object,
      headers: [
        {
          text: "ID",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Ride Type",
          align: "left",
          sortable: false,
          value: "customer"
        },
        {
          text: "Fee",
          align: "left",
          sortable: false,
          value: "driver"
        },
        {
          text: "Kick In Time (Minutes)",
          align: "left",
          sortable: false,
          value: "description"
        },
        {
          text: "Action",
          align: "left",
          sortable: false,
          value: "description"
        },
      ]
    };
  },
  methods: {
    remove(userRideTypeWaitTime) {
      console.log("Remove called");
      console.log(userRideTypeWaitTime);

      var url = `${this.$store.state.apiUrl}/customer/ride_type_wait_time/delete?id=${userRideTypeWaitTime.id}`;

      var self = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
         self.$emit('reload');
        })
        .catch(function(err) {
          console.error(err);
        });
    },
   
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
